import { render, staticRenderFns } from "./VariantSifterWorkspaceGuide.vue?vue&type=template&id=273f97ff&scoped=true&"
import script from "./VariantSifterWorkspaceGuide.vue?vue&type=script&lang=js&"
export * from "./VariantSifterWorkspaceGuide.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterWorkspaceGuide.vue?vue&type=style&index=0&id=273f97ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f97ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273f97ff')) {
      api.createRecord('273f97ff', component.options)
    } else {
      api.reload('273f97ff', component.options)
    }
    module.hot.accept("./VariantSifterWorkspaceGuide.vue?vue&type=template&id=273f97ff&scoped=true&", function () {
      api.rerender('273f97ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterWorkspaceGuide.vue"
export default component.exports